import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import { getLeadingZeroNumber } from '../../../helpers/stringHelper'

const Clock = (props) => {
  const { hideWhenEmpty } = props

  const [hour, setHour] = useState(0)
  const [minute, setMinute] = useState(0)

  const hideTime = hideWhenEmpty && hour == 0 && minute == 0

  const timerCallback = () => {
    const date = new Date()

    if (hour !== date.getHours() || minute !== date.getMinutes()) {
      setHour(date.getHours())
      setMinute(date.getMinutes())
    }
  }

  useEffect(() => {
    const timerInterval = setInterval(timerCallback, 1000)
    return function () {
      clearInterval(timerInterval)
    }
  })

  return (
    <div style={{ opacity: hideTime ? 0 : 1 }}>
      {getLeadingZeroNumber(hour, 2)}:{getLeadingZeroNumber(minute, 2)}
    </div>
  )
}

Clock.defaultProps = {
  hideWhenEmpty: false,
}

Clock.propTypes = {
  hideWhenEmpty: PropTypes.bool,
}

export { Clock }
